var t = require('i18n').t

module.exports = Em.Controller.extend({
    text: function() {
        return t('loading_screen.starting')
    }.property()
})
